import {
  CHANGE_CURRENT_STEP_4_INDIVIDUAL,
  CHANGE_CURRENT_STEP_4_INSTITUTION,
  CHANGE_ACCOUNT_EMAIL,
  CHANGE_APPLY_TYPE,
  CHANGE_CURRENT_STEP_4_INDIVIDUAL_ADDITIONAL,
  SET_IDV_COMPLETED,
  CHANGE_STEP_HIDDEN_STATUS,
  UPDATE_STEP_STATUS,
  SET_CHECK_ADDITIONAL_KYC_PROCESS_LIST,
  UPDATE_ADDITIONAL_PROCESS_INDEX
} from "./mutation-types";

// inital state
const state = {
  applyType: -1, //-1 无类型 0 个人 1 公司
  enableVeriff: true,
  currentStep4Individual: 0,
  currentStep4Institution: 0,
  accountEmail: "",
  idvCompleted: false,
  kycStepLists4Individual: [
    {
      view: "PersonalInfo",
      status: "process",
      title: "Personal Info",
      valid: false
    },
    {
      view: "BankingInfo",
      status: "wait",
      title: "Banking Info",
      valid: false
    },
    {
      view: "Questionnaire",
      status: "wait",
      title: "Questionnaire",
      valid: false
    },
    {
      view: "Identification",
      status: "wait",
      title: "Identification",
      valid: false
    }
  ],
  kycStepLists4Institution: [
    {
      view: "GeneralInfo",
      status: "process",
      title: "General",
      valid: false
    },
    {
      view: "Documents",
      status: "wait",
      title: "Documentation",
      valid: false
    },
    {
      view: "BankingInfo",
      status: "wait",
      title: "Banking Info",
      valid: false
    },
    {
      view: "Questionnaire",
      status: "wait",
      title: "Questionnaire",
      valid: false
    },
    {
      view: "Representives",
      status: "wait",
      title: "Representives",
      valid: false
    },
    {
      view: "BeneficialOwners",
      status: "wait",
      title: "Beneficial Owners",
      valid: false
    }
  ],
  kycStepLists4IndividualAdditional: [
    {
      name: "additional.individual.personalInfo",
      status: "process", // process | finish
      title: "BASIC INFORMATION",
      desc: "Check your name and DOB are correct",
      hidden: false,
      includes: [
        "additional.individual.enterEmail",
        "additional.individual.personalInfo"
      ]
    },
    {
      name: "additional.individual.addressInfo",
      status: "process",
      title: "ADDRESS",
      desc: "Enter or Check your address",
      hidden: false,
      includes: [
        "additional.individual.addressInfo",
        "additional.individual.poa",
        "additional.individual.phoneInfo"
      ]
    },
    {
      name: "additional.individual.kycSurvey",
      status: "process",
      title: "QUESTIONNAIRE",
      desc: "Fast survey for a full experience",
      hidden: false,
      includes: ["additional.individual.kycSurvey"]
    },
    {
      name: "additional.individual.verifyIdentify",
      status: "process",
      title: "VERIFY IDENTITY",
      desc: "Take a selfie and photos your ID",
      hidden: false,
      includes: ["additional.individual.verifyIdentify"]
    }
  ],
  kycProcessSteps4IndividualAdditional: {
    email_verified: "additional.individual.enterEmail",
    first_name: "additional.individual.personalInfo",
    middle_name: "additional.individual.personalInfo",
    last_name: "additional.individual.personalInfo",
    aliases: "additional.individual.personalInfo",
    birthdate: "additional.individual.personalInfo",
    place_of_birth: "additional.individual.personalInfo",
    citizenship: "additional.individual.personalInfo",
    country_iso2_code: "additional.individual.addressInfo",
    city: "additional.individual.addressInfo",
    state: "additional.individual.addressInfo",
    address: "additional.individual.addressInfo",
    address_line_2: "additional.individual.addressInfo",
    zipcode: "additional.individual.addressInfo",
    ssn: "additional.individual.addressInfo",
    proof_of_residence_file: "additional.individual.poa",
    phone: "additional.individual.phoneInfo",
    questionnaire: "additional.individual.kycSurvey",
    veriff_id: "additional.individual.verifyIdentify"
  },
  addtionalKycProcessIndex: 0,
  checkAdditionalKycProcessList: []
};
// getters
const getters = {};
// actions
const actions = {
  changeCurrentStep4Individual({ commit }, stepData) {
    commit(CHANGE_CURRENT_STEP_4_INDIVIDUAL, stepData);
  },
  changeCurrentStep4Institution({ commit }, stepData) {
    commit(CHANGE_CURRENT_STEP_4_INSTITUTION, stepData);
  },
  changeAccountEmail({ commit }, accountEmail) {
    commit(CHANGE_ACCOUNT_EMAIL, accountEmail);
  },
  changeApplyType({ commit }, applyType) {
    commit(CHANGE_APPLY_TYPE, applyType);
  },
  changeCurrentStep4IndividualAdditional({ commit }, stepData) {
    commit(CHANGE_CURRENT_STEP_4_INDIVIDUAL_ADDITIONAL, stepData);
  },
  setIdvCompleted({ commit }, value) {
    commit(SET_IDV_COMPLETED, value);
  },
  changeStepHiddenStatus({ commit }, value) {
    commit(CHANGE_STEP_HIDDEN_STATUS, value);
  },
  updateStepStatus({ commit }, value) {
    commit(UPDATE_STEP_STATUS, value);
  },
  setAdditionalCheckKycProcessList({ commit }, value) {
    commit(SET_CHECK_ADDITIONAL_KYC_PROCESS_LIST, value);
  },
  updateAdditionalKycProcessIndex({ commit }, value = 0) {
    commit(UPDATE_ADDITIONAL_PROCESS_INDEX, value);
  }
};
// mutations
const mutations = {
  [CHANGE_APPLY_TYPE](state, applyType) {
    state.applyType = applyType;
  },
  [CHANGE_CURRENT_STEP_4_INDIVIDUAL](state, stepData) {
    if (state.currentStep4Individual > stepData) {
      // 说明是后退的操作
      state.kycStepLists4Individual[state.currentStep4Individual].status =
        "wait";
      state.kycStepLists4Individual[stepData].status = "process";
    } else {
      // 说明是前进的操作
      state.kycStepLists4Individual[state.currentStep4Individual].status =
        "finish";
      state.kycStepLists4Individual[stepData].status = "process";
    }
    state.currentStep4Individual = stepData;
  },
  [CHANGE_CURRENT_STEP_4_INSTITUTION](state, stepData) {
    if (state.currentStep4Institution > stepData) {
      // 说明是后退的操作
      state.kycStepLists4Institution[state.currentStep4Institution].status =
        "wait";
      state.kycStepLists4Institution[stepData].status = "process";
    } else {
      // 说明是前进的操作
      state.kycStepLists4Institution[state.currentStep4Institution].status =
        "finish";
      state.kycStepLists4Institution[stepData].status = "process";
    }
    state.currentStep4Institution = stepData;
  },
  [CHANGE_ACCOUNT_EMAIL](state, accountEmail) {
    state.accountEmail = accountEmail;
  },
  [CHANGE_CURRENT_STEP_4_INDIVIDUAL_ADDITIONAL](state, fields) {
    // 将fields转换为对应的步骤名
    const requiredSteps = new Set();
    fields.forEach(field => {
      const step = state.kycProcessSteps4IndividualAdditional[field];
      if (step) {
        requiredSteps.add(step);
      }
    });

    state.kycStepLists4IndividualAdditional.forEach(step => {
      const hasRequiredField = step.includes.some(include =>
        requiredSteps.has(include)
      );
      step.hidden = !hasRequiredField;
    });
  },
  [SET_IDV_COMPLETED](state, value) {
    state.idvCompleted = value;
  },
  [CHANGE_STEP_HIDDEN_STATUS](state, value) {
    // 写死即可
    state.kycStepLists4IndividualAdditional[3].hidden = value;
  },
  [UPDATE_STEP_STATUS](state, value) {
    const { name, isFirstTime } = value;

    const statusFinishPathName = [
      "additional.individual.autoVerify",
      "additional.individual.verifySuccess",
      "additional.individual.verifyFailed"
    ];
    // 首先找到当前路由所在的步骤
    const currentStepIndex = state.kycStepLists4IndividualAdditional.findIndex(
      step => step.includes.includes(name)
    );

    // 更新所有步骤的状态
    state.kycStepLists4IndividualAdditional.forEach((step, index) => {
      if (index < currentStepIndex) {
        step.status = "finish"; // 之前的步骤标记为完成
        if (isFirstTime) {
          step.hidden = true;
        }
      } else {
        if (statusFinishPathName.includes(name)) {
          step.status = "finish"; // 之后的步骤标记为等待
        } else {
          step.status = "process"; // 之后的步骤标记为等待
        }
      }
    });
  },
  [SET_CHECK_ADDITIONAL_KYC_PROCESS_LIST](state, value) {
    state.checkAdditionalKycProcessList = value;
  },
  [UPDATE_ADDITIONAL_PROCESS_INDEX](state, value) {
    state.addtionalKycProcessIndex = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
